import { Phone, MapPin, Clock, Mail } from "lucide-react";

export const Footer = ({ hotel }) => (
  <footer className="bg-[#0A192F] border-t border-[#C5A059]/20 py-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <p className="font-serif-display text-2xl font-bold text-[#F8F6F0]">{hotel?.name}</p>
          <p className="text-[#C5A059] text-[10px] uppercase tracking-[0.35em] mt-1">Eufaula · Alabama</p>
          <p className="text-[#F8F6F0]/60 text-sm leading-relaxed mt-5 max-w-xs">
            Modern lakeside comfort in the heart of Alabama's most historic river town. Book direct and save.
          </p>
        </div>
        <div className="space-y-4 text-sm">
          <a href={hotel?.phone_href || "tel:+13346870000"} className="flex items-center gap-3 text-[#F8F6F0]/80 hover:text-[#C5A059] transition-colors" data-testid="footer-phone-link">
            <Phone size={16} className="text-[#C5A059]" /> {hotel?.phone}
          </a>
          <a href={`mailto:${hotel?.email}`} className="flex items-center gap-3 text-[#F8F6F0]/80 hover:text-[#C5A059] transition-colors" data-testid="footer-email-link">
            <Mail size={16} className="text-[#C5A059]" /> {hotel?.email}
          </a>
          <a href={hotel?.maps_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[#F8F6F0]/80 hover:text-[#C5A059] transition-colors" data-testid="footer-address-link">
            <MapPin size={16} className="text-[#C5A059]" /> {hotel?.address}
          </a>
          <p className="flex items-center gap-3 text-[#F8F6F0]/80" data-testid="footer-hours">
            <Clock size={16} className="text-[#C5A059]" /> Check-in {hotel?.check_in} · Check-out {hotel?.check_out}
          </p>
        </div>
        <div className="flex flex-col items-start gap-4">
          <a
            href={hotel?.phone_href || "tel:+13346870000"}
            className="bg-[#C5A059] text-[#0A192F] hover:bg-[#D4AF37] px-7 py-3.5 rounded-full font-semibold shadow-md transition-all flex items-center gap-2"
            data-testid="footer-call-to-book-button"
          >
            <Phone size={16} /> Call to Book Direct
          </a>
        </div>
      </div>
      <div className="border-t border-[#F8F6F0]/10 mt-12 pt-6 text-center text-xs text-[#F8F6F0]/35">
        © {new Date().getFullYear()} {hotel?.name}. Eufaula, Alabama. All rights reserved.
      </div>
    </div>
  </footer>
);
